import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash'
import Fuse from 'fuse.js'
import moment from 'moment'
import { read, utils } from 'xlsx';

import Menu from "../../../helpers/Menu";
import { Dialog } from "primereact/dialog";
import { Button, Table } from "../../../helpers";

import Loading from "../../../common/Loading";
import ButtonGroup from "../../../common/ButtonGroup";

import AddVendorRCItem from "./AddVendorRCItem";
import EditendorRCItem from "./EditVendorRCItem";
import ErrorMsgsModal from "../../BuyerRateContract/Components/ErrorMsgsModal";

import SearchBar from "./Search";

import { insertVendorRateContract } from "../../../services/api/vendorRateContract";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchVendorRateContractItems, setIsSearchVisible } from "../../../services/redux/reducers/vendorRateContractItems/vendorRateContractItems";

import { excelSerialToJSDate, getDateString, getDuplicatesInArray, getListDiscountAndUnitPrices, getProductName, getProductSpecification } from "../../../utils";


const CoverageDetailsNew = (props) => {
    const {
        isLoading,
        setIsLoading,
        materialBrands, 
        materialCategories, 
        vendorRateContract,
        vendorRCTypes, 
        vendorRCCoverageTypes, 
        sellerCompanies,
        allVendorRateContractItems
    } = props

    const [visibleErrorMessageModal, setVisibleErrorMessageModal] = useState(false)
    const [visibleAddVendorRCItemModal, setVisibleAddVendorRCItemModal] = useState(false)
    const [visibleEditVendorRCItemModal, setVisibleEditVendorRCItemModal] = useState(false)

    const [selectedVendorRCItemObj, setSelectedVendorRCItemObj] = useState({})

    const [tableColumns, setTableColumns] = useState([])
    const [vendorRCTypeFields, setVendorRCTypeFields] = useState([])
    const [vendorRCCategoryFields, setVendorRCCategoryFields] = useState([])
    const [errorMessagesData, setErrorMessagesData] = useState([])

    const [materialBrandSuggestions, setMaterialBrandSuggestions] = useState([])

    const dispatch = useDispatch()

    const actionMenu = useRef(null)
    const uploadMenu = useRef(null)
    const fileInputRef = useRef(null)

    const loading = useSelector(state => state.vendorRateContractItems.loading)
    const isSearchVisible = useSelector(state => state.vendorRateContractItems.isSearchVisible)
    const vendorRateContractItemsData = useSelector(state => state.vendorRateContractItems.vendorRateContractItems)
    const materialDetails = useSelector(state => state.vendorRateContractItems.materialDetails)
    const paginationParams = useSelector(state => state.vendorRateContractItems.paginationParams)
    const searchParams = useSelector(state => state.vendorRateContractItems.searchParams)

    useEffect(() => {
        setMaterialBrandSuggestions(materialBrands)
    }, [materialBrands])

    useEffect(() => {
        getTableColumns()
        getRequiredRCCatergoryFields()
        getRequiredRCTypeFields()
    }, [vendorRateContract, vendorRateContractItemsData])

    const vendorRCCoverageTypesInfo = {
        "Brand - Category": {columns: ["Brand", "Category", "Valid From", "Valid To"], validateKeys: ["brandId", "categoryId", "validFrom"]},
        "Brand - Product Name": {columns: ["Brand", "Product Name", "Valid From", "Valid To"], validateKeys: ["brandId", "productName", "validFrom"]},
        "Brand - Product - Variant Name": {columns: ["Brand", "Product Name", "Variant Name", "Valid From", "Valid To"], validateKeys: ["brandId", "productName", "variantName", "validFrom"]},
        "Material Id": {columns: ["Material Id", "Product Name", "Product Specs"], validateKeys: ["materialId"]}
    }

    const vendorRCTypesInfo = {
        "Discount": {columns: ["Discount"], validateKeys: ["discount", "leadTime"]},
        "ListPrice - Discount": {columns: ["List Price", "Discount", "Fixed Price", "List Price Date"], validateKeys: ["listPriceDate", "discount", "listPrice", "leadTime"]},
        "Fixed Price": {columns: ["Fixed Price", "List Price Date"], validateKeys: ["listPriceDate", "contractPrice", "leadTime"]}
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event)
        }
    ]

    if (!vendorRateContract.isNew){
        actionButtons.push({
            icon: "pi pi-filter",
            label: "Filter",
            command: () => dispatch(setIsSearchVisible(!isSearchVisible))
        })
    }
    
    const uploadOptions = [
        {
            label: 'Upload File',
            command: () => {
                const fileInput = document.getElementById('upload-xl-form')
                if (fileInput) {
                    fileInput.click()
                }
            },
            permissions: [220]
        }
    ]

    const materialBrandFuzzSearch = useCallback(new Fuse(materialBrands, {
        keys: ['brandName'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.brandName.replace(/\s+/g, '')
        },
    }), [materialBrands])

    const getTableColumns = () => {
        const tableHeaders = {
            "Brand": {header: 'Brand', body: getBrandColumnBody},
            "Category": {header: 'Category', body: getCategoryColumnBody},
            "Product Name": {header: 'Product Name', body: getProductNameBody},
            "Product Specs": {header: 'Product Specs', body: getProductSpecsBody},
            "Variant Name": {header: 'Variant Name', body: getVariantNameBody},
            "Material Id": {header: 'Material Id', body: getMaterialIdBody},
            "Discount": {header: 'Discount', body: getDiscountBody},
            "List Price": {header: 'List Price', body: getListPriceBody},
            "Fixed Price": {header: 'Fixed Price', body: getFixedPriceBody},
            "List Price Date": {header: 'List Price Date', body: getPriceListDateBody},
            "Lead Time": {header: 'Lead Time', body: getLeadTimeBody},
            "Valid From": {header: 'Valid From', body: getValidFromBody},
            "Valid To": {header: 'Valid To', body: getValidToBody},
            "Edit": {header: 'Edit', body: getEditColumnBody}
        }

        let tableColumns = []
        let tableHeadersArr = []

        let relatedVendorRCType = vendorRCTypes.find(eachVendorRCType => eachVendorRCType.vendorRCTypeId === vendorRateContract.vendorRCTypeId)
        let relatedVendorRCCoverageType = vendorRCCoverageTypes.find(eachVendorRCCoverageType => eachVendorRCCoverageType.vendorRCCoverageTypeId === vendorRateContract.vendorRCCoverageTypeId)
     
        tableHeadersArr.push(...vendorRCCoverageTypesInfo[relatedVendorRCCoverageType.vendorRCCoverageType].columns)
        tableHeadersArr.push(...vendorRCTypesInfo[relatedVendorRCType.vendorRCType].columns)
        tableHeadersArr.push("Lead Time", "Edit")

        tableHeadersArr.map(eachHeader => {
            tableColumns.push(tableHeaders[eachHeader])
        })

        setTableColumns(tableColumns)
    }


    const actionMenuItems = [
        {
            label: 'Add Vendor RC Item',
            icon: '',
            command: () => setVisibleAddVendorRCItemModal(true),
            permissions: [228]
        }
    ]

    const getEditColumnBody = (row) => {
        return (
                <Button onClick={()=> {setSelectedVendorRCItemObj(row) ;setVisibleEditVendorRCItemModal(true)}} style={{ background: "none", border: "none", cursor: "pointer" }} permissions={[215]}> 
                    <i className="pi pi-file-edit" onClick={()=> {setSelectedVendorRCItemObj(row) ;setVisibleEditVendorRCItemModal(true)}} style={{ fontSize: "16px", color:"#00baaa"}}/>
                </Button>
            // <i className="pi pi-file-edit" onClick={()=> {setSelectedVendorRCItemObj(row) ;setVisibleEditVendorRCItemModal(true)}} style={{fontSize : "20px", cursor: "pointer"}}></i>
        )
    }

    const getBrandColumnBody = (row) => {
        let relatedBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === row.brandId)

        return (
            <>{relatedBrand?.brandName}</>
        )
    }

    const getCategoryColumnBody = (row) => {
        let relatedCategory = materialCategories.find(eachMaterialCategory => eachMaterialCategory.categoryId === row.categoryId)

        return (
            <>{relatedCategory?.categoryName}</>
        )
    }

    const getMaterialIdBody = (row) => {
        return (
            <div>{row?.materialId}</div> 
        )
    }

    const getDiscountBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)
        return (
            <>{relatedVendorRateContractItem?.discount}</>
        )
    }

    const getListPriceBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)
        
        return (
            <>{relatedVendorRateContractItem?.listPrice}</>
        )
    }

    const getFixedPriceBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)

        return (
            <>{relatedVendorRateContractItem?.contractPrice}</>
        )
    }

    const getPriceListDateBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)

        return (
            <>{relatedVendorRateContractItem?.listPriceDate ? getDateString(relatedVendorRateContractItem?.listPriceDate) : "-"}</>
        )
    }

    const getValidFromBody = (row) => {
        return (
            <>{row?.validFrom ? getDateString(row.validFrom) : "-"}</>
        )
    }

    const getValidToBody = (row) => {
        return (
            <>{row?.validTo ? getDateString(row.validTo) : "-"}</>
        )
    }

    const getProductNameBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)
        let productName = null
        if (relatedVendorRateContractItem?.materialId){
            const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === parseInt(row.materialId))
            let relatedBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === relatedMaterial?.brandId)
            productName = getProductName(relatedBrand?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)
        }else {
            productName = relatedVendorRateContractItem?.productName
        }

        return (
           <>{productName}</>  
        )
    }

    const getProductSpecsBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)
        let productSpecification = null
        if (relatedVendorRateContractItem?.materialId){
            const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === parseInt(row.materialId))
            productSpecification = getProductSpecification(relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)
        }

        return (
           <>{productSpecification}</>  
        )
    }

    const getVariantNameBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)

        return (
           <>{relatedVendorRateContractItem?.variantName}</>
        )
    }

    const getLeadTimeBody = (row) => {
        let relatedVendorRateContractItem = vendorRateContractItemsData.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === row.vendorRateContractItemId)

        return (
            <>{relatedVendorRateContractItem?.leadTime}</>  
        )      
    }

    const getRequiredRCCatergoryFields = () => {
        let vendorRCCategoryFields = []
        if (vendorRateContract.vendorRCCoverageTypeId){
            let relatedVendorRCCoverageType = vendorRCCoverageTypes.find(eachVendorRCCoverageType => eachVendorRCCoverageType.vendorRCCoverageTypeId === vendorRateContract.vendorRCCoverageTypeId)
            vendorRCCategoryFields.push(...vendorRCCoverageTypesInfo[relatedVendorRCCoverageType.vendorRCCoverageType].columns)

            setVendorRCCategoryFields(vendorRCCategoryFields)
        }
    }

    const getRequiredRCTypeFields = () => {
        let vendorRCTypeFields = []
        if (vendorRateContract.vendorRCTypeId){
            let relatedVendorRCType = vendorRCTypes.find(eachVendorRCType => eachVendorRCType.vendorRCTypeId === vendorRateContract.vendorRCTypeId)
            vendorRCTypeFields.push(...vendorRCTypesInfo[relatedVendorRCType.vendorRCType].columns)

            setVendorRCTypeFields(vendorRCTypeFields)
        }
    }

    const materialBrandSearchMethod = (event) => {
        if (event.query === "") {
            setMaterialBrandSuggestions([...materialBrands])
        }
        else {
            const searchResults = materialBrandFuzzSearch.search(event.query)
            const relatedBrands = searchResults.map(eachProduct => eachProduct.item)
            setMaterialBrandSuggestions(relatedBrands)
        }
    }

    const handleUploadFile = async (e) => {
        setIsLoading(true)
        const reader = new FileReader()
        if (e.target.files[0]){
            reader.readAsArrayBuffer(e.target.files[0])
            reader.onload = async (e) => {
                const data = e.target.result

                const workbook = read(data)
                const worksheet = workbook.Sheets[workbook.SheetNames[0]]
                const productsParsedData = utils.sheet_to_json(worksheet)

                uploadFileValidation(productsParsedData)
            }
        }
        e.target.value = ""
        setIsLoading(false)
    }

    let rcDataTypes = []

    if (vendorRateContract.vendorRCTypeId === 1){
        rcDataTypes = [
            {columnName: "SRNO", keyName: 'srNo', dataType: 'Integer', required: true, nullValidations: ["ALL"] },
            {columnName: "VENDOR RATE CONTRACT ITEM ID", keyName: 'vendorRateContractItemId', dataType: 'Integer', required: false, nullValidations: []},
            {columnName: "STATUS", keyName: "status", dataType: 'String', required: true, nullValidations: ["ALL"]},
            {columnName: "MATERIAL ID", keyName: 'materialId', dataType: 'Integer', required: false, nullValidations: ["ALL"]},
            {columnName: "DISCOUNT", keyName: 'discount', dataType: 'Real', required: true, nullValidations: ["ALL"]},
            {columnName: "LEAD TIME", keyName: 'leadTime', dataType: 'Integer', required: true, nullValidations: ["ALL"]},
        ]
    }else if (vendorRateContract.vendorRCTypeId === 2){
        rcDataTypes = [
            {columnName: "SRNO", keyName: 'srNo', dataType: 'Integer', required: true, nullValidations: ["ALL"] },
            {columnName: "VENDOR RATE CONTRACT ITEM ID", keyName: 'vendorRateContractItemId', dataType: 'Integer', required: false, nullValidations: []},
            {columnName: "STATUS", keyName: "status", dataType: 'String', required: true, nullValidations: ["ALL"]},
            {columnName: "MATERIAL ID", keyName: 'materialId', dataType: 'Integer', required: false, nullValidations: ["ALL"]},
            {columnName: "LIST PRICE", keyName: "listPrice", dataType: 'Real', required: true, nullValidations: ["ALL"]},
            {columnName: "DISCOUNT", keyName: 'discount', dataType: 'Real', required: true, nullValidations: ["ALL"]},
            {columnName: "LEAD TIME", keyName: 'leadTime', dataType: 'Integer', required: true, nullValidations: ["ALL"]},
            {columnName: "LIST PRICE DATE", keyName: 'listPriceDate', dataType: 'Date', required: true, nullValidations: ["ALL"]},
        ]
    }else if (vendorRateContract.vendorRCTypeId === 3){
        rcDataTypes = [
            {columnName: "SRNO", keyName: 'srNo', dataType: 'Integer', required: true, nullValidations: ["ALL"] },
            {columnName: "VENDOR RATE CONTRACT ITEM ID", keyName: 'vendorRateContractItemId', dataType: 'Integer', required: false, nullValidations: []},
            {columnName: "STATUS", keyName: "status", dataType: 'String', required: true, nullValidations: ["ALL"]},
            {columnName: "MATERIAL ID", keyName: 'materialId', dataType: 'Integer', required: false, nullValidations: ["ALL"]},
            // {columnName: "LIST PRICE", keyName: "listPrice", dataType: 'Real', required: true, nullValidations: ["ALL"]},
            // {columnName: "DISCOUNT", keyName: 'discount', dataType: 'Real', required: true, nullValidations: ["ALL"]},
            {columnName: "CONTRACT PRICE", keyName: 'contractPrice', dataType: 'Real', required: true, nullValidations: [""]},
            {columnName: "LEAD TIME", keyName: 'leadTime', dataType: 'Integer', required: true, nullValidations: ["ALL"]},
            {columnName: "LIST PRICE DATE", keyName: 'listPriceDate', dataType: 'Date', required: true, nullValidations: ["ALL"]},
        ]
    }

    const checkDataType = (value, type) => {
        if (type === "Integer"){
            let obj = {
                isValid: !Number.isNaN(parseInt(value)),
                value: !Number.isNaN(parseInt(value)) ? parseInt(value) : value
            }
            return obj
        }else if (type === "Real"){
            let obj = {
                isValid: !Number.isNaN(parseFloat(value)),
                value: !Number.isNaN(parseFloat(value)) ? parseFloat(value) : value
            }
            return obj
        }else if (type === "String"){
            let obj = {
                isValid: _.isString(value.toString()),
                value: value.toString().trim()
            }
            return obj
        }else if (type === "Date"){
            if (_.isInteger(value)){
                value = excelSerialToJSDate(value)
            }
            console.log("value1111111", new Date(value))
            let obj = {
                isValid: moment(value, "YYYY-MM-DD", true).isValid(),
                value: value
            }
            return obj
        }else if (type === "GSTRate"){
            let obj = {
                isValid: !_.isNaN(value) && !(parseFloat(value) > 0 && parseFloat(value) < 1),
                value: parseFloat(value)
            }
            return obj
        }
    }

    const uploadFileValidation = async (uploadSheetData) => {
        let newVendorRateContractItems = []
        let errorMsgsArr = []

        for (let j = 0; j < uploadSheetData.length; j++) {
            const rateContractProduct = uploadSheetData[j]            

            let newVendorRateContractItem = {
                statusId: 1,
                isNew: rateContractProduct["VENDOR RATE CONTRACT ITEM ID"] ? false : true
            }

            let relatedVendorRateContractItem = null
            console.log("rateContractProduct", rateContractProduct)
            rcDataTypes.map(eachDataType => {
                let relatedRateContractValue = rateContractProduct[eachDataType.columnName]

                if (!relatedRateContractValue && (eachDataType.columnName !== "DISCOUNT" && relatedRateContractValue !== 0)){
                    if (eachDataType.nullValidations.length){
                        if (eachDataType.nullValidations.includes("ALL")){
                            errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Missing', severity: 'error', detail: `value missing`})
                        }
                    }
                }
                else if (relatedRateContractValue || (eachDataType.columnName === "DISCOUNT" && relatedRateContractValue === 0)){
                    let { isValid, value } = checkDataType(relatedRateContractValue, eachDataType.dataType)
                    
                    if (isValid){
                        if (!eachDataType.maxLength || (eachDataType.maxLength && value.length <= eachDataType.maxLength)){
                            if (eachDataType.columnName === "VENDOR RATE CONTRACT ITEM ID"){
                                relatedVendorRateContractItem = allVendorRateContractItems.find(eachVendorRateContractItem => eachVendorRateContractItem.vendorRateContractItemId === value)
                                if(!relatedVendorRateContractItem){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Invalid', severity: 'error', value: value, detail: `Provided Vendor Rate Contract Id is not present in this catalogue.`})
                                }
                            }

                            if (eachDataType.columnName === "MATERIAL ID"){
                                const isMaterialIdAlreadyExists = allVendorRateContractItems.some(eachVendorRateContractItem => eachVendorRateContractItem.materialId === value && eachVendorRateContractItem.statusId === 1)

                                if (isMaterialIdAlreadyExists && newVendorRateContractItem.isNew){
                                    errorMsgsArr.push({field: 'Material Id', type: 'Duplicate', severity: 'error', srNo: rateContractProduct["SRNO"], detail: 'Given Material Id already Exists.'})
                                }
                            }

                            if (eachDataType.columnName === 'STATUS'){
                                if (!['ACTIVE', 'INACTIVE'].includes(rateContractProduct[eachDataType.columnName])){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} "${value}" is Invalid, it should be either ACTIVE or INACTIVE.`})
                                }
                            }
                            if (eachDataType.columnName === 'LIST PRICE DATE') {
                                console.log("value", value)
                                if(!value || !isValid) {
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} ${value} is invalid.`})
                    
                                }
                            }

                            newVendorRateContractItem[eachDataType.keyName] = value
                            newVendorRateContractItem[eachDataType.columnName] = value
                        }else {
                            errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Exceeded Length', value: value, detail: `Provided ${eachDataType.columnName} ${value} is not acceptable as it exceeded the length(${eachDataType.maxLength}).`})
                        }
                    }else {
                        errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} ${value} is invalid.`})
                    }  
                }
            })

            if (vendorRateContract.vendorRCTypeId === 3) {
                let columnToBeConsidered = "listPrice"
            
                let listPrice = newVendorRateContractItem.listPrice ? newVendorRateContractItem.listPrice : null
                let unitPrice = newVendorRateContractItem.contractPrice ? newVendorRateContractItem.contractPrice : null
                let discount = newVendorRateContractItem.discount ? newVendorRateContractItem.discount : null
            
                const calculatedValues = getListDiscountAndUnitPrices(columnToBeConsidered, listPrice || 0, discount || 0, unitPrice || 0)
            
                const allValuesProvided = listPrice !== null && unitPrice !== null && discount !== null
            
                if (allValuesProvided) {
                    const isPricesMatching = 
                        listPrice === calculatedValues.listPrice &&
                        unitPrice === calculatedValues.unitPrice &&
                        discount === calculatedValues.discount
            
                    if (!isPricesMatching) {
                        errorMsgsArr.push({field: 'Validation', srNo: rateContractProduct["SRNO"], type: 'Mismatch', severity: 'error', detail: `Calculated values do not match the provided values.`})
                    }
                } else {
                    listPrice = listPrice ? listPrice : calculatedValues.listPrice
                    unitPrice = unitPrice ? unitPrice : calculatedValues.unitPrice
                    discount = discount ? discount : calculatedValues.discount
            
                    newVendorRateContractItem.listPrice = listPrice
                    newVendorRateContractItem.contractPrice = unitPrice
                    newVendorRateContractItem.discount = discount
                }
            }
            
            newVendorRateContractItems.push(newVendorRateContractItem)
        }
        const duplicateMaterials = getDuplicatesInArray(newVendorRateContractItems, ["materialId"])

        if (duplicateMaterials.length){
            const uniqueMaterials = _.uniqBy(duplicateMaterials, "materialId")
            const uniqueMaterialIds = uniqueMaterials.map(eachMaterial => eachMaterial.materialId)
            const materialIdStr = uniqueMaterialIds.join(", ")

            setIsLoading(false)
            if (uniqueMaterialIds.length){
                return dispatch(raiseToast({ severity: 'error', summary: 'Material Ids', detail: `Given Upload sheet has duplicate material Ids: ${materialIdStr}`}))
            }
        }

        if (errorMsgsArr.length){
            setErrorMessagesData(errorMsgsArr)
            setVisibleErrorMessageModal(true)
            return
        }

        let materialIds = []
        let updatedVendorRateContractItems = []

        newVendorRateContractItems.map(eachVendorRateContractItem => {
            materialIds.push(eachVendorRateContractItem.materialId)

            if (vendorRateContract.vendorRCTypeId !== 1){
                let columnToBeConsidered = vendorRateContract.vendorRCTypeId === 2 ? "listPrice" : "contractPrice"
                let calculatedValues = getListDiscountAndUnitPrices(columnToBeConsidered, eachVendorRateContractItem.listPrice, eachVendorRateContractItem.discount, eachVendorRateContractItem.contractPrice)
            
                eachVendorRateContractItem.listPrice = calculatedValues.listPrice
                eachVendorRateContractItem.contractPrice = calculatedValues.unitPrice
                eachVendorRateContractItem.discount = calculatedValues.discount
            }
            updatedVendorRateContractItems.push(eachVendorRateContractItem)
        })

        if (window.confirm("Do you want to continue..?")){
            let data = {
                vendorRateContract: vendorRateContract,
                vendorRateContractItems: updatedVendorRateContractItems
            }

            setIsLoading(true)
            const vendorRateContractInsertionRes = await insertVendorRateContract(data)

            if (vendorRateContractInsertionRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', detail: vendorRateContractInsertionRes.data.error, summary: 'Vendor Rate Contract is not Inserted', life: 3000}))
            }

            let vendorRCItemParams = {
                paginator: true,
                pageNo: 1,
                limitedPagination: true,
                getCount: false,
                vendorRCCoverageTypeId: vendorRateContract.vendorRCCoverageTypeId,
                vendorRateContractIds: [vendorRateContract.vendorRateContractId],
                ...searchParams
            }
            dispatch(fetchVendorRateContractItems({...vendorRCItemParams}))
            dispatch(raiseToast({severity:'success', detail: 'Vendor Rate Contract created Successfully', life: 3000}))
            
            setIsLoading(false)
        }
    }

    const handlePageChange = async (e) => {
        let vendorRCItemParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            vendorRCCoverageTypeId: vendorRateContract.vendorRCCoverageTypeId,
            vendorRateContractIds: [vendorRateContract.vendorRateContractId],
            ...searchParams
        }
        if (vendorRCItemParams.searchBy !== "all") {
            vendorRCItemParams[vendorRCItemParams.searchBy] = vendorRCItemParams.searchText.trim()
        }
        dispatch(fetchVendorRateContractItems({ ...vendorRCItemParams }))
    }

    let companyName = vendorRateContract.companyId
    if (typeof (vendorRateContract.companyId) === "number") {
        companyName = sellerCompanies?.find(eachCompany => eachCompany.companyId === vendorRateContract.companyId)
    }

    let activeVendorRateContractItems = vendorRateContractItemsData.filter(eachVendorRateContractItem => eachVendorRateContractItem.statusId === 1)

    return (
        <>
            <Loading visible={isLoading}/>   
            <div className=" mt-3">
                <div className="flex flex-column md:flex-row md:justify-content-end mt-1 mb-2">
                    <div className="flex gap-2 justify-content-end">
                        <Menu id="action-menu" model={actionMenuItems} popup menuRef={actionMenu} />
                        <ButtonGroup buttons={actionButtons} />
                        {
                            vendorRateContract.vendorRCCoverageTypeId === 4 ?
                            <div className="ml-1">
                                <Menu id='upload-menu' model={uploadOptions} popup menuRef={uploadMenu} />
                                <Button icon="pi pi-upload" className="h-2rem w-2rem p-2" aria-controls="upload-menu" onClick={(event) => uploadMenu.current.toggle(event)} />  
                                <input type="file" accept=".xlsx, .xls" className='hidden' id='upload-xl-form' onChange={handleUploadFile} ref={fileInputRef} />
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="requirement-table" style={{ order: "1", width: isSearchVisible && !vendorRateContract.isNew ? "82%" : "100%" }}>
                        <div className='p-card mb-0'>
                            <div className="" >
                                <Table
                                    loading={loading}
                                    lazy
                                    page={paginationParams.pageNo}
                                    onPageChange={(e) => handlePageChange(e)}
                                    totalRecords={paginationParams.totalRecords}
                                    rows={paginationParams.recordsPerPage}
                                    tableColumns={tableColumns}
                                    data={activeVendorRateContractItems}
                                    globalFilterFields={vendorRCCategoryFields}
                                    scrollable={"true"}
                                    scrollHeight="550px"
                                    dataKey="vendorRateContractItemId"
                                    paginator
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isSearchVisible && !vendorRateContract.isNew ?
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <SearchBar 
                                vendorRateContractId={vendorRateContract.vendorRateContractId} 
                                vendorRateContract={vendorRateContract}
                                materialBrands={materialBrands}
                                materialCategories={materialCategories}
                            />
                        </div>
                        :
                        null
                    }
                </div>
            </div>
            {
                visibleAddVendorRCItemModal ? 
                    <Dialog header="Add Vendor RC Item" visible={visibleAddVendorRCItemModal} style={{ width: '40vw', minHeight: "35%" }} onHide={() => setVisibleAddVendorRCItemModal(false)}>
                        <AddVendorRCItem 
                            materialBrands={materialBrandSuggestions}
                            materialCategories={materialCategories}
                            vendorRCTypeFields={vendorRCTypeFields}
                            vendorRCCategoryFields={vendorRCCategoryFields}
                            vendorRCCoverageTypesInfo={vendorRCCoverageTypesInfo}
                            vendorRCTypes={vendorRCTypes}
                            vendorRCCoverageTypes={vendorRCCoverageTypes}
                            vendorRCTypesInfo={vendorRCTypesInfo}
                            vendorRateContract={vendorRateContract}
                            setIsLoading={setIsLoading}
                            setVisibleAddVendorRCItemModal={setVisibleAddVendorRCItemModal}
                            materialBrandSearchMethod={materialBrandSearchMethod}
                        />
                    </Dialog>
                    :
                    ""
            }
            {
                visibleEditVendorRCItemModal ? 
                    <Dialog header="Edit Vendor RC Item" visible={visibleEditVendorRCItemModal} style={{ width: '40vw', minHeight: "35%" }} onHide={() => setVisibleEditVendorRCItemModal(false)}>
                        <EditendorRCItem 
                            materialBrands={materialBrandSuggestions}
                            materialCategories={materialCategories}
                            vendorRCTypeFields={vendorRCTypeFields}
                            vendorRCCategoryFields={vendorRCCategoryFields}
                            vendorRCCoverageTypesInfo={vendorRCCoverageTypesInfo}
                            vendorRCTypes={vendorRCTypes}
                            vendorRCCoverageTypes={vendorRCCoverageTypes}
                            vendorRCTypesInfo={vendorRCTypesInfo}
                            vendorRateContract={vendorRateContract}
                            setIsLoading={setIsLoading}
                            setVisibleEditVendorRCItemModal={setVisibleEditVendorRCItemModal}
                            selectedVendorRCItemObj={selectedVendorRCItemObj}
                            materialBrandSearchMethod={materialBrandSearchMethod}
                        />
                    </Dialog>
                    :
                    ""
            }
            <ErrorMsgsModal
                errorMessagesData={errorMessagesData} 
                visibleErrorMessageModal={visibleErrorMessageModal} 
                setVisibleErrorMessageModal={setVisibleErrorMessageModal} 
                rateContractProducts={vendorRateContractItemsData}
                skipAndUpdateNotAllowed={true}
            />
        </>
    )
}

export default CoverageDetailsNew